module.exports = __webpack_public_path__ + "static/media/christ.fbba419a.jpeg";